import React from 'react';

import classNames from 'classnames/bind';
import style from './MobileHeader.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

class MobileHeader extends React.Component {
  render() {
    const { title, description } = this.props;

    return (
      <div
        className={ctx('mobile-header')}
        style={{ backgroundImage: `url(${'images/header-bg-mobile.jpg'})` }}
      >
        <div className={ctx('title')}>{title}</div>
        <div className={ctx('description')}>{description}</div>
        <div className={ctx('kommersant')}>
          <img src={'images/kommersant_logo.png'} width="162px" height="18px" />
        </div>
      </div>
    );
  }
}

export default MobileHeader;
